// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ARYo","content":"styles_content__2WLgT","row":"styles_row__2sBPq","footer":"styles_footer__3edPM","phraseLength":"styles_phraseLength__3ztB2"};